import type { SSEResponse, SSEStreamService } from '@patsnap-utils/sse';
import type { PsHttpService } from '@patsnap/tahiti-core';

export interface PsHttpSSEOptions {
    baseURL?: string;
    url: string;
    method?: string;
    data?: Record<string, any>;
    headers?: Record<string, string>;
}

export const PsHttpSSE = Symbol('SSEPsHttp');

export interface PsHttpSSE<T> extends SSEStreamService<T> {
    init(options: PsHttpSSEOptions): this;
    /**
     * 消息回调
     * @description 当收到消息时, 会触发该回调
     * @param callback
     * @returns
     */
    onMessage(callback: (data: SSEResponse<T>) => void): this;
    /**
     * 完成回调
     * @description 当返回 status 为 FINISH 时, 会触发该回调
     * @param callback
     * @returns
     */
    onFinish(callback: () => void): this;
    /**
     * 解析错误回调
     * @description 当解析错误时, 会触发该回调
     * @param callback
     * @returns
     */
    onParseError(callback: (error: any) => void): this;
}

export const FactoryPsHttpSSE = Symbol('FactoryPsHttpSSE');

export type FactoryPsHttpSSE = <T>() => PsHttpSSE<T>;

export interface PsHttpRequest {
    request: PsHttpService['request'];
}

export const PsHttpRequest = Symbol('PsHttpRequest');
